<template>
  <div class="conf-wrp">
    <div class="content-wrp">
      <div class="content">
        <el-form class="form" :model="value" :rules="rules" ref="form" label-width="174px">
         <section>
            <div class="title">
              <span>基础设置</span>
            </div>
            <div class="conf">
              <el-form-item label="自动删除超限SKU配置：">
                <el-checkbox v-model="value.isAutoTrimSku" :true-label="1" :false-label="0">铺货时自动截取删除超过平台发布商品要求上限的sku</el-checkbox>
              </el-form-item>
              <el-form-item label="店铺品牌设置：">
                <BrandSettingConfig v-if="shopList.length" ref="branchSettingConfig" v-model="brandConfList" :shopList="shopList" />
                <span class="no-shops" v-else>暂无平台店铺</span>
              </el-form-item>
              <el-form-item label="类目外品牌设置：">
                <BrandSettingOtherConfig
                  v-if="shopList.length"
                  ref="branchSettingConfig"
                  platform="wxsph"
                  v-model="dataSourceCategory"
                  :shopList="shopList"
                />
                <span class="no-shops" v-else>暂无平台店铺</span>
              </el-form-item>
            </div>
          </section>
          <section>
              <div class="title">
                  <span>款式编码来源字段</span>
              </div>
              <div class="conf">
                  <el-form-item label="款式编码来源字段：" prop="outerType">
                        <el-radio-group v-model="outerTypeValue">
                          <el-radio :label="1">商品ID</el-radio>
                          <el-radio :label="2">商家编码</el-radio>
                      </el-radio-group>
                  </el-form-item>
                  <el-form-item>
                      <span style="font-size: 12px">从微信小店下载商品资料到基础资料时可以选择平台商家编码作为平台资料商品的款式编码来源</span>
                  </el-form-item>
              </div>
          </section>
          <section>
            <div class="title">
              <span>运费模板设置</span>
            </div>
            <div class="conf">
              <el-form-item label="运费设置:" prop="shipSet" label-width="120px">
                <div class="ship-wrp" v-if="shopList.length > 0">
                  <div class="item" v-for="(item, idx) in shopList" :key="idx">
                    <div class="shopname">
                      <img class="shop-img" :src="item.icon"/>
                      <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px;">
                          <el-image :src="item.channelIcon" style="width: 18px; height: 18px;overflow: unset;top: 4px;"></el-image>
                      </el-tooltip>
                      <span>{{ item.shortTitle || item.title }}</span>
                    </div>
                    <el-select
                      :loading="selectLoading"
                      v-model="shipsValue[item.id]"
                      placeholder="请选择运费模板"
                      clearable
                      @visible-change="changeSelect(item.id, item.userId)"
                      width="150px"
                    >
                      <el-option
                        v-for="ship in shipsTemplate[item.id]"
                        :key="ship.id"
                        :label="ship.name"
                        style="width: 150px"
                        :title="ship.name"
                        :value="ship.id"
                      >
                      </el-option>
                    </el-select>
                    <div><el-link class="no-border" @click="refreshTemplate(item.id, item.userId)">刷新模板</el-link></div>
                  </div>
                </div>
                <span v-else class="no-shops">暂无平台店铺</span>
              </el-form-item>
            </div>
          </section>
          <section>
            <div class="title">
              <span>退货地址设置</span>
              <!-- <pre>{{returnAddressTemplate}}</pre>
              <pre>{{returnAddressValue}}</pre> -->
            </div>
            <div class="conf">
              <el-form-item label="退货地址:" prop="returnAddressSet" label-width="120px">
                <div class="ship-wrp" style="display:inline-block;" v-if="shopList.length && Object.keys(returnAddressValue).length">
                  <div class="item" v-for="(item, idx) in shopList" :key="idx">
                    <div class="shopname">
                      <img :src="item.icon" class="shop-img" />
                      <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px">
                        <el-image :src="item.channelIcon" style="width: 18px; height: 18px; overflow: unset; top: 4px"></el-image>
                      </el-tooltip>
                      <span>{{ item.shortTitle || item.title }}</span>
                    </div>
                    <template>
                      <el-select
                        :loading="selectLoading"
                        v-model="returnAddressValue[item.id].addressId"
                        placeholder="请选择退货地址"
                        clearable
                        @change="($event)=>handleReturnAddressChange(item.id, returnAddressValue[item.id].addressId,$event)"
                        @visible-change="visible => visibleChangeReturnAddress(item.id, item.userId)"
                        width="500px"
                      >
                        <el-option
                          v-for="addr in returnAddressTemplate[item.id]"
                          :key="addr.addressId"
                          :label="addr.addressName"
                          :value="addr.addressId"
                          style="width: 500px"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </div>
                </div>
                <span v-else class="no-shops">暂无平台店铺</span>
              </el-form-item>
            </div>
          </section>
          <PriceConf ref="PriceConfRef" platform="wxsph" :priceList="value.price" :shopPriceConf="value.shopPriceConf"></PriceConf>
          <section>
              <div class="title">
                  <span>更多设置</span>
              </div>
              <div class="conf">
                <el-form-item label="假一赔三:" prop="fakeOnePayThree" >
                  <el-radio-group v-model="otherConfig.fakeOnePayThree">
                      <el-radio :label="1">支持</el-radio>
                      <el-radio :label="0">不支持</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="坏损包退:" prop="damageGuarantee" >
                  <el-radio-group v-model="otherConfig.damageGuarantee">
                      <el-radio :label="0">不支持坏损包退</el-radio>
                      <el-radio :label="1">支持坏损包退</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="换货:" prop="exchangeSupport" >
                  <el-radio-group v-model="otherConfig.exchangeSupport">
                      <el-radio :label="0">不支持换货</el-radio>
                      <el-radio :label="1">支持换货</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="运费险:" prop="freightInsurance" >
                  <el-radio-group v-model="otherConfig.freightInsurance">
                      <el-radio :label="0">不支持运费险</el-radio>
                      <el-radio :label="1">支持运费险</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
          </section>
          <div class="btns">
            <el-button type="primary" @click="save">保存模板</el-button>
            <el-button @click="back">返回</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/prod.scss';
import { getDistributionConfig, updateDistributionConfig, getWxsphTemplateList,getWxsphAddressList } from '@servers/prod/conf/index.js';
import { processAddressItems } from '@/servers/prod/center/wxh'
import BrandSettingConfig from './components/BrandSettingConfig/index.vue';
import BrandSettingOtherConfig from './components/BrandSettingOtherConfig/index.vue';
import PriceConf from './components/PriceConf.vue';
import { cloneDeep } from 'lodash';
const PLATFORMID = 'wxsph';

export default {
  name: 'WxsphConf',
  props: {
    back: Function,
  },
  components: {
    BrandSettingConfig,
    BrandSettingOtherConfig,
    PriceConf,
  },
  provide() {
    return {
      platform:'wxsph',
    }
  },
  data() {
    return {
      shopList: [],
      value: {
        isAutoTrimSku: 0
      },
      selectLoading: false,
      rules: {},
      shipsValue: {}, // 运费模板
      shipsTemplate: {}, // 运费模板列表
      outerTypeValue: '',
      returnAddressValue: {}, // 退货地址值
      returnAddressTemplate: {}, // 退货地址模板列表
      returnAddressTemplateCaches: {}, // 退货地址模板
      //更多设置
      otherConfig:{
        fakeOnePayThree: 0,
        damageGuarantee: 0,
        exchangeSupport: 0,
        freightInsurance: 0,
      },
      categoryBrandRelationsList:[],
      brandConfList: [],
    }
  },
  computed: {
    dataSourceCategory: {
      get() {
        if (!this.categoryBrandRelationsList?.length) {
          return [];
        }
        return this.categoryBrandRelationsList.flatMap(item =>
          item.relations.map(childRelation => ({
            ...childRelation,
            previewCategoryId: childRelation.categoryId,
            parent: { shopId: item.shopId },
          }))
        );
      },
      set(next) {
        const grouped = {};
        (next || []).forEach(row => {
          const shopId = row?.parent?.shopId;
          if (!shopId) return;
          if (!grouped[shopId]) grouped[shopId] = [];
          const copy = { ...row };
          delete copy.parent;
          delete copy.previewCategoryId;
          grouped[shopId].push(copy);
        });
        this.categoryBrandRelationsList = Object.keys(grouped).map(shopId => ({
          shopId: isNaN(Number(shopId)) ? shopId : Number(shopId),
          shopType: PLATFORMID,
          relations: grouped[shopId],
        }));
      },
    },
  },
  methods: {
    async getConf() {
      const res = await getDistributionConfig({ shopType: PLATFORMID });
      this.outerTypeValue = res.outerType || 2;
      const shopList = this.$store.getters.shops_authorizedShops('wxsph');
      this.shopList = shopList.filter(item => item.enableStatus);
      const { templateList, categoryBrandRelations = [],brandConfList} = res || {};
      this.intiTemplate(shopList, templateList);
      this.categoryBrandRelationsList = categoryBrandRelations
      this.handleUniqData(brandConfList || []);
      const afterSaleAddressTemplateList = processAddressItems(res?.afterSaleAddressTemplateList || []);
      this.initReturnAddressTemplate(afterSaleAddressTemplateList || []);
      this.value.price = res.price ? JSON.parse(res.price) : [];
      this.value.shopPriceConf = res.shopPriceConf ? JSON.parse(res.shopPriceConf) : [];
      this.value.isAutoTrimSku = res.isAutoTrimSku || 0
      // 更多设置处理
      if(res.otherConfig && res.otherConfig !== '{}'){
        try{
          this.otherConfig = JSON.parse(res.otherConfig);
        }catch(e){console.log(e)}
      }
    },
    handleUniqData(value) {
      const list = cloneDeep(value);
      const data = list.map((item, index) => {
        item.id = index + '_' + item.shopIds.join('');
        return item;
      });
      this.brandConfList = data;
    },
    intiTemplate(shopList, templateList = []) {
      const ships = {};
      const shopUserIdMap = {};
      for (let shop of shopList) {
        ships[shop.id] = '';
        shopUserIdMap[shop.userId] = shop.id;
        this.shipsTemplate[shop.id] = [];
      }
      const shipsTemp = {};
      if (shopList.length && templateList) {
        templateList.forEach(item => {
          item.shopId = shopUserIdMap[item.shopId] || item.shopId;
          ships[item.shopId] = item.templateId;
          if (this.shipsTemplate[item.shopId] && !this.shipsTemplate[item.shopId].length) {
            shipsTemp[item.shopId] = [{ name: item.templateName, id: item.templateId }];
          }
        });
      }
      this.shipsTemplate = shipsTemp;
      this.shipsValue = ships;
    },
    async getTemplateList(userId) {
      const list = await getWxsphTemplateList({ userId: userId });
      if (list) {
        return list.map(ship => {
          return {
            name: ship.templateName,
            id: ship.templateId,
          };
        });
      }
      return [];
    },
    async refreshTemplate(shopId, userId) {
      this.selectLoading = true;
      const list = await this.getTemplateList(userId);
      this.shipsTemplate[shopId] = list;
      const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
      if (idx === -1) {
        this.shipsValue[shopId] = '';
      }
      this.selectLoading = false;
      this.$message.success('刷新模板成功');
    },

    async changeSelect(shopId, userId) {
      if (
        !this.shipsTemplate[shopId] ||
        !this.shipsTemplate[shopId].length ||
        (this.shipsTemplate[shopId].length === 1 && this.shipsTemplate[shopId][0].id === this.shipsValue[shopId])
      ) {
        this.selectLoading = true;
        const list = await this.getTemplateList(userId);
        const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
        if (idx === -1) {
          this.shipsValue[shopId] = '';
        }
        this.shipsTemplate[shopId] = list;
        this.selectLoading = false;
      }
    },
    findTemplateName(shopid, tempId) {
      if (!this.shipsTemplate[shopid]) return '';
      for (let item of this.shipsTemplate[shopid]) {
        if (item.id === tempId) {
          return item.name;
        }
      }
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const templateList = [];
          Object.keys(this.shipsValue).forEach(id => {
            const name = this.findTemplateName(id, this.shipsValue[id]);
            // if (this.shipsValue[id] && name) {
            const channel = this.shopList.find(shop => shop.id == id)?.channel
            templateList.push({
              shopId: id,
              templateId: this.shipsValue[id] || null,
              templateName: name || null,
              channel
            });
            // }
          });
          
          const afterSaleAddressTemplateList = []; // 添加退货地址列表
          this.shopList.forEach(shop => {
            // ... existing code ...

            // 处理退货地址数据
            const returnAddressValue = this.returnAddressValue[shop.id];
            const { cityName = '',countyName = '',detailInfo = '',provinceName = ''} = returnAddressValue.addressInfo ||{}
            if (returnAddressValue?.addressId) {
              afterSaleAddressTemplateList.push({
                shopId: shop.id,
                addressId: returnAddressValue.addressId,
                addressName: returnAddressValue.addressName
              });
            }
          });
          let [commConf,shopConf] = this.$refs.PriceConfRef.getData();
          const res = await updateDistributionConfig({
            shopType: PLATFORMID,
            templateList: templateList,
            afterSaleAddressTemplateList,
            outerType: this.outerTypeValue,
            otherConfig:JSON.stringify(this.otherConfig),
            categoryBrandRelations: this.categoryBrandRelationsList,
            brandConfList: this.brandConfList,
            price: JSON.stringify(commConf),
            shopPriceConf:JSON.stringify(shopConf),
            isAutoTrimSku: this.value.isAutoTrimSku
          });
          if (res) {
            this.$message.success('保存成功');
          }
        }
      });
    },

     // 初始化退货地址模板
     initReturnAddressTemplate(afterSaleAddressTemplateList) {
      const shopList = this.shopList;
      
      // 初始化每个店铺的退货地址值
      shopList.forEach(shop => {
        const { id } = shop;
        if (!this.returnAddressValue[id]) {
          this.$set(this.returnAddressValue, id, {
            shopId: id,
            addressId: '',
            addressName: null
          });
        }
        if (!this.returnAddressTemplate[id]) {
          this.$set(this.returnAddressTemplate, id, []);
        }
      });

      // 如果有初始数据，更新对应的值
      if (afterSaleAddressTemplateList?.length) {
        afterSaleAddressTemplateList.forEach(temp => {
          if (temp.shopId) {
             // 尝试解析 addressName 为 addressName
            let addressName = temp.addressName;
            if (!addressName && temp.addressName) {
              try {
                addressName = JSON.parse(temp.addressName);
              } catch (e) {
                console.error('解析 addressName 失败:', e);
                addressName = temp.addressName;
              }
            }
            const _temp = {
              shopId: temp.shopId,
              addressId: temp.addressId || '',
              addressName: addressName|| null
            }
            this.$set(this.returnAddressValue, temp.shopId, _temp);
            this.$set(this.returnAddressTemplate, temp.shopId, [_temp]);
          }
        });
      }
    },

    // 处理退货地址变更
    handleReturnAddressChange(shopId, addressId, event) {
      if (!addressId) {
        // 处理清空选择的情况
        this.$set(this.returnAddressValue, shopId, {
          shopId,
          addressId: '',
          addressName: null
        });
        return;
      }

      const selectedAddress = this.returnAddressTemplate[shopId]?.find(item => item.addressId === addressId);
      if (selectedAddress) {
        this.$set(this.returnAddressValue, shopId, {
          shopId,
          addressId: selectedAddress.addressId,
          addressName: selectedAddress.addressName
        });
      }
    },

    // 获取退货地址列表
    async getReturnAddressList({shopId, userId, isRefresh}) {
      const addressCacheType = 'returnAddressCacheType';
      const cacheKey = `${shopId}_${addressCacheType}`;
      
      if (this.returnAddressTemplateCaches[cacheKey] && !isRefresh) {
        this.returnAddressTemplate[shopId] = this.returnAddressTemplateCaches[cacheKey];
      } else {
        this.selectLoading = true;
        try {
          const params = {
            userId,
            // offset: 0,
            // limit: 100,
            // searchUsed: false,
          }
          const res = await getWxsphAddressList(params);
          if (res && res.length) {
            const list = res.map(item => ({
              addressId: item.addressId,
              addressName: item.name
            }));
            // this.returnAddressTemplate[shopId] = list;
            // this.returnAddressTemplateCaches[cacheKey] = list;
            this.$set(this.returnAddressTemplate, shopId, list)
            this.$set(this.returnAddressTemplateCaches, cacheKey, list)
          } else {
            this.returnAddressTemplate[shopId] = [];
          }
        } catch (error) {
          console.error('获取退货地址失败:', error);
          this.returnAddressTemplate[shopId] = [];
        } finally {
          this.selectLoading = false;
        }
      }
    },

    // 退货地址下拉框显示变化处理
    async visibleChangeReturnAddress(shopId, userId) {
      await this.getReturnAddressList({shopId, userId});
    },
  },
  mounted() {
    this.getConf();
  },
};
</script>

<style lang="scss">
</style>